/**
 * Normaliserar Vue-klassvärden till en enkel "space-separated" sträng.
 * Supporterar:
 * - string
 * - string[]
 * - record med bool (t.ex. `{ 'mt-0': true, 'mb-0': false }`)
 */
export function classValueToString(value: unknown): string {
  if (!value) return ''

  if (typeof value === 'string') return value

  if (Array.isArray(value)) {
    return value.filter(Boolean).join(' ')
  }

  if (typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
    return entries
      .filter(([, enabled]) => Boolean(enabled))
      .map(([className]) => className)
      .join(' ')
  }

  return String(value)
}

